import { render } from "./BuiltinLogin.vue?vue&type=template&id=40174ef2&ts=true"
import script from "./BuiltinLogin.vue?vue&type=script&lang=ts"
export * from "./BuiltinLogin.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__